module.exports = __webpack_public_path__ + "img/top_bar-1.386f4d23.svg";